// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-index-template-jsx": () => import("./../src/templates/index-template.jsx" /* webpackChunkName: "component---src-templates-index-template-jsx" */)
}

